(function() {
  var POPUP_SELECTOR = '[data-banner-popup]';
  var VIEWPORT_MARGIN = 8;
  var CLOSE_DELAY_MS = 220;
  var resizeRafId = 0;

  function getOpenPopups() {
    return Array.prototype.slice.call(document.querySelectorAll(POPUP_SELECTOR + '.is-open'));
  }

  function closePopup(popupEl) {
    if (!popupEl || !popupEl.classList.contains('is-open')) return;
    popupEl.classList.remove('is-visible');
    popupEl.classList.add('is-closing');
    window.setTimeout(function() {
      popupEl.classList.remove('is-open', 'is-closing');
      popupEl.setAttribute('aria-hidden', 'true');
    }, CLOSE_DELAY_MS);
  }

  function openPopup(popupEl) {
    if (!popupEl) return;

    getOpenPopups().forEach(function(item) {
      if (item !== popupEl) closePopup(item);
    });

    popupEl.classList.add('is-open');
    popupEl.setAttribute('aria-hidden', 'false');
    window.requestAnimationFrame(function() {
      popupEl.classList.remove('is-closing');
      popupEl.classList.add('is-visible');
      if (typeof popupEl._bannerPopupClampToViewport === 'function') {
        popupEl._bannerPopupClampToViewport();
      }
    });
  }

  function movePopupToBody(popupEl) {
    if (popupEl.parentNode !== document.body) {
      document.body.appendChild(popupEl);
    }
  }

  function clampOffsets(dialogEl, offsetX, offsetY) {
    var rect = dialogEl.getBoundingClientRect();
    var halfViewportW = window.innerWidth / 2;
    var halfViewportH = window.innerHeight / 2;
    var minX = VIEWPORT_MARGIN + (rect.width / 2) - halfViewportW;
    var maxX = halfViewportW - VIEWPORT_MARGIN - (rect.width / 2);
    var minY = VIEWPORT_MARGIN + (rect.height / 2) - halfViewportH;
    var maxY = halfViewportH - VIEWPORT_MARGIN - (rect.height / 2);

    if (minX > maxX) {
      minX = 0;
      maxX = 0;
    }
    if (minY > maxY) {
      minY = 0;
      maxY = 0;
    }

    return {
      x: Math.min(Math.max(offsetX, minX), maxX),
      y: Math.min(Math.max(offsetY, minY), maxY)
    };
  }

  function setupPopupDrag(popupEl) {
    var dialogEl = popupEl.querySelector('[data-banner-popup-dialog]');
    var dragHandleEl = popupEl.querySelector('[data-banner-popup-drag]');
    if (!dialogEl || !dragHandleEl) return;

    function applyClampedPosition(offsetX, offsetY) {
      var clamped = clampOffsets(dialogEl, offsetX, offsetY);
      dialogEl.dataset.dragX = String(clamped.x);
      dialogEl.dataset.dragY = String(clamped.y);
      dialogEl.style.setProperty('--banner-popup-drag-x', clamped.x + 'px');
      dialogEl.style.setProperty('--banner-popup-drag-y', clamped.y + 'px');
      return clamped;
    }

    popupEl._bannerPopupClampToViewport = function() {
      var currentX = parseFloat(dialogEl.dataset.dragX || '0') || 0;
      var currentY = parseFloat(dialogEl.dataset.dragY || '0') || 0;
      applyClampedPosition(currentX, currentY);
    };

    var dragState = {
      active: false,
      startX: 0,
      startY: 0,
      baseX: 0,
      baseY: 0,
      nextX: 0,
      nextY: 0,
      rafId: 0
    };

    function flushDragPosition() {
      dragState.rafId = 0;
      var clamped = applyClampedPosition(dragState.nextX, dragState.nextY);
      dragState.nextX = clamped.x;
      dragState.nextY = clamped.y;
    }

    dragHandleEl.addEventListener('pointerdown', function(event) {
      if (event.button !== 0) return;

      dragState.active = true;
      dragState.startX = event.clientX;
      dragState.startY = event.clientY;
      dragState.baseX = parseFloat(dialogEl.dataset.dragX || '0') || 0;
      dragState.baseY = parseFloat(dialogEl.dataset.dragY || '0') || 0;

      var clampedStart = applyClampedPosition(dragState.baseX, dragState.baseY);
      dragState.baseX = clampedStart.x;
      dragState.baseY = clampedStart.y;

      popupEl.classList.add('is-dragging');
      document.body.classList.add('banner-popup-dragging');
      dragHandleEl.setPointerCapture(event.pointerId);
      event.preventDefault();
    });

    dragHandleEl.addEventListener('pointermove', function(event) {
      if (!dragState.active) return;
      dragState.nextX = dragState.baseX + (event.clientX - dragState.startX);
      dragState.nextY = dragState.baseY + (event.clientY - dragState.startY);
      if (!dragState.rafId) {
        dragState.rafId = window.requestAnimationFrame(flushDragPosition);
      }
    });

    function endDrag() {
      if (!dragState.active) return;
      dragState.active = false;
      if (dragState.rafId) {
        window.cancelAnimationFrame(dragState.rafId);
        dragState.rafId = 0;
      }
      flushDragPosition();
      popupEl.classList.remove('is-dragging');
      document.body.classList.remove('banner-popup-dragging');
    }

    dragHandleEl.addEventListener('pointerup', endDrag);
    dragHandleEl.addEventListener('pointercancel', endDrag);
  }

  function setupPopup(popupEl) {
    if (!popupEl || popupEl.dataset.bannerPopupInit === 'true') return;
    popupEl.dataset.bannerPopupInit = 'true';
    movePopupToBody(popupEl);
    setupPopupDrag(popupEl);
  }

  function init(context) {
    var scope = context || document;
    scope.querySelectorAll(POPUP_SELECTOR).forEach(setupPopup);
  }

  function onDocumentClick(event) {
    var trigger = event.target.closest('[data-banner-popup-target]');
    if (trigger) {
      event.preventDefault();
      var targetId = trigger.getAttribute('data-banner-popup-target');
      if (!targetId) return;
      openPopup(document.getElementById(targetId));
      return;
    }

    var closeBtn = event.target.closest('[data-banner-popup-close]');
    if (!closeBtn) return;
    event.preventDefault();
    closePopup(closeBtn.closest(POPUP_SELECTOR));
  }

  function onResize() {
    if (resizeRafId) return;
    resizeRafId = window.requestAnimationFrame(function() {
      resizeRafId = 0;
      getOpenPopups().forEach(function(popupEl) {
        if (typeof popupEl._bannerPopupClampToViewport === 'function') {
          popupEl._bannerPopupClampToViewport();
        }
      });
    });
  }

  function onKeyDown(event) {
    if (event.key !== 'Escape') return;
    getOpenPopups().forEach(closePopup);
  }

  function onSectionLoad() {
    init(document);
  }

  document.addEventListener('click', onDocumentClick);
  document.addEventListener('keydown', onKeyDown);
  window.addEventListener('resize', onResize);
  document.addEventListener('shopify:section:load', onSectionLoad);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      init(document);
    });
  } else {
    init(document);
  }

  window.BannerPopup = window.BannerPopup || {};
  window.BannerPopup.init = init;
  window.BannerPopup.open = function(id) {
    openPopup(document.getElementById(id));
  };
  window.BannerPopup.close = function(id) {
    closePopup(document.getElementById(id));
  };
})();
